import { EPageActionTypes } from '../../types/page/pageType';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export type TToggleStickyScrollBtn = ITypedReduxAction<EPageActionTypes.ToggleStickyScrollBtn, boolean>;

export const toggleStickyScrollBtn: (isVisible: boolean) => TToggleStickyScrollBtn = actionGenerator<
  EPageActionTypes.ToggleStickyScrollBtn,
  boolean
>(EPageActionTypes.ToggleStickyScrollBtn);
